export type SearchForm = SearchGroup;

export const enum SearchLogicalOperator {
	And = 1,
	Or = 2,
}

export interface SearchGroup {
	Conditions?: SearchCondition[];
	Groups?: SearchGroup[];
	LogicalOperator?: SearchLogicalOperator;
}

export interface SearchCondition {
	Property: string;
	Operator: number;
	Value: unknown[];
}
